export default __webpack_public_path__ + "static/media/checkMark.401aa274.svg";